__turbopack_context__.v({
  "buttonWrapper": "qL69xG_buttonWrapper",
  "figure": "qL69xG_figure",
  "fullWidth": "qL69xG_fullWidth",
  "hyperlink": "qL69xG_hyperlink",
  "image": "qL69xG_image",
  "list": "qL69xG_list",
  "wrapper": "qL69xG_wrapper",
});
